import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ContextProvider } from './context/ContextProvider';
import { DashboardDataProvider } from './context/DashboardDataProvider';
import { CommonDataProvider } from './context/CommonDataProvider';
import { AdvancedDataProvider } from './context/AdvancedDataProvider';
import { LandingDataProvider } from './context/LandingDataProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ContextProvider>
    <DashboardDataProvider>
      <CommonDataProvider>
        <AdvancedDataProvider>
          <LandingDataProvider>
            <App />
            </LandingDataProvider>
            </AdvancedDataProvider>
          </CommonDataProvider>

    </DashboardDataProvider>
    </ContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals